export const QUERY_PARAM = {
    ORIGIN: 'origin',
    V: 'v',
    UTM_SOURCE: 'utm_source',
    UTM_MEDIUM: 'utm_medium',
    ORG: 'org',
    ID_ALERTA: 'idAlerta',
    UI: 'ui',
    SEM: 'sem',
    UTM_CONTENT: 'utm_content',
    REDIRECT_TO_RETENTION_INTERMEDIATE: 'redirect_to_retention_intermediate',
}

export function isPaidQueryParam(queryParam: string) {
    return queryParam == QUERY_PARAM.ORIGIN || queryParam == QUERY_PARAM.V
}

export function isRetentionQueryParam(queryParam: string) {
    return queryParam == QUERY_PARAM.UTM_SOURCE
        || queryParam == QUERY_PARAM.UTM_MEDIUM
        || queryParam == QUERY_PARAM.ORG
        || queryParam == QUERY_PARAM.ID_ALERTA
        || queryParam == QUERY_PARAM.UI
        || queryParam == QUERY_PARAM.SEM
        || queryParam == QUERY_PARAM.UTM_CONTENT
        || queryParam == QUERY_PARAM.REDIRECT_TO_RETENTION_INTERMEDIATE
}